// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mt-2";
export var interactiveWrapper = "_mt-0";
export var shippingHoverPreview = "_mt-4";
export var summaryBadgeTrigger = "_mt-1";
export var widgetHoverPreviewList = "_mt-3";
export var widgetPreviewScale = "_mt-5";